import { memo, MouseEventHandler } from 'react';

import { Button, Card, CardSection, Text } from '@/lib/v2/components';
import { ArrowIcon } from '@/lib/v2/icons/outline';

import { PlayVideo } from '@/src/modules/AutomationModuleNew/components/PlayVideo';

type TypeAutomatizationCardProps = {
  description?: string;
  buttonText: string;
  linkText: string;
  onClickButton?: MouseEventHandler<HTMLButtonElement>;
  urlLearnMore?: string;
  videoUrl?: string;
  portraitImage?: string;
};

const TypeAutomatizationCard = ({
  buttonText,
  linkText,
  urlLearnMore,
  onClickButton,
  videoUrl,
  portraitImage,
  description,
}: TypeAutomatizationCardProps) => {
  return (
    <Card noShadow>
      <CardSection className="h-full" paddingX="medium" paddingY="medium">
        <div className="flex h-full flex-col items-center gap-6">
          <PlayVideo enableBorder portraitImage={portraitImage} videoUrl={videoUrl} />
          <div className="flex w-full flex-1 flex-col items-center justify-between gap-4">
            <div className="w-full">
              <Text alignment="center" renderHtml={description} variant="text" />
            </div>
            <div className="flex w-full flex-col items-center gap-4">
              <Button secondary standard iconLeft={<ArrowIcon />} onClick={onClickButton}>
                {buttonText}
              </Button>
              <Text
                link
                as="a"
                color="primary"
                href={urlLearnMore}
                target="_blank"
                variant="text-sm"
              >
                {linkText}
              </Text>
            </div>
          </div>
        </div>
      </CardSection>
    </Card>
  );
};

export default memo(TypeAutomatizationCard);
